import stopVideo from "../../../src/scripts/components/video/stop-video.js";
import $ from 'jquery';

$(function () { 

  stopVideo.onScrollInit();
  stopVideo.load();
});